import { PlanManagePayload, ChangePaymentMethodResponse, ChangePaymentMethodPayload } from './interfaces';
import { usePost, usePut } from '@selfserve/react-hooks';
import { apiEndpoints } from '@selfserve/react-utils';

export const usePlanUnsubscribe = (id: string) =>
  usePost<PlanManagePayload, any>(
    apiEndpoints.unsubscribePlan.replace(':id', id)
  );

export const usePlanUpdate = (id: string) =>
  usePost<PlanManagePayload, any>(apiEndpoints.updatePlan.replace(':id', id));

export const useChangePaymentMethod = () =>
  usePut<ChangePaymentMethodPayload, ChangePaymentMethodResponse>(
    apiEndpoints.billingInfo
  );

export * from '@selfserve/react-common-data' 
export * from './interfaces';
export * from './schemas';
